


















import Vue from "vue";
import CheckboxGroup from "@/components/Form/CheckboxGroup.vue";
import CheckboxGroupPost from "@/components/Form/CheckboxGroupPost.vue";
import { mapMutations } from "vuex";
import { SET_IS_LAYER_SELECTED } from "./../../store/types";
export default Vue.extend({
  name: "LayerSelect",

  props: {
    layer: {
      type: Object,
      required: true
    }
  },

  components: {
    CheckboxGroup,
    CheckboxGroupPost
  },

  computed: {
    isLayerSelected: {
      get(): boolean {
        return this.layer.isSelected;
      },
      set(value: boolean): void {
        this.setIsLayerSelected({ id: this.layer.id, value });
        this.$emit("layerSelect", { id: this.layer.id, value });
      }
    }
  },

  methods: {
    ...mapMutations({
      setIsLayerSelected: SET_IS_LAYER_SELECTED
    })
  }
});
